<div class="form-container">
  @if (team && !isLoading){

  <div class="fixed-buttons">
    <div class="button-container">
      <button class="action-button" mat-raised-button matTooltip="Gå tillbaka till föregående sida"
        (click)="goBack()"><mat-icon fontIcon="arrow_back" class="button-icon-no-text"></mat-icon></button>

      @if(isPT) {
      <button class="action-button" mat-raised-button matTooltip="Ladda om maskin"
        [disabled]="!this.teamHasChanged && (!this.teamForm.dirty || !this.teamForm.valid)"
        (click)="reloadMachineDetailsView()">
        <mat-icon fontIcon="refresh" class="button-icon-no-text"></mat-icon>
      </button>

      <button class="action-button main-action-button" mat-raised-button (click)="saveChanges()"
        [disabled]="!this.teamHasChanged && (!this.teamForm.dirty || !this.teamForm.valid)">Spara</button>

      }

    </div>
  </div>

  <form class="detail-form" [formGroup]="teamForm">

    <div class="base-info-container">
      <h4 class="form-header">Grunduppgifter</h4>

      <div class="base-info-forms">
        <mat-form-field floatLabel="always" [appearance]="team.id === 0 ? 'outline' : 'fill'"
          [ngClass]="{'fm-always-readonly-mandatory-mat-form-field' : team.id > 0}">
          <mat-label>Maskinlagskod</mat-label>
          <input matInput type="string" formControlName="teamId" [readonly]="team.id > 0" />
          @if (teamForm.get('teamId')?.invalid && teamForm.get('teamId')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('teamId')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="team.id === 0 ? 'outline' : 'fill'"
          [ngClass]="{'fm-always-readonly-mandatory-mat-form-field' : team.id > 0}">
          <mat-label>Ansvar</mat-label>
          <input matInput type="string" formControlName="responsibility" [readonly]="team.id > 0" />
          @if (teamForm.get('responsibility')?.invalid && teamForm.get('responsibility')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('responsibility')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Namn</mat-label>
          <input matInput type="string" formControlName="name" />
          @if (teamForm.get('name')?.invalid && teamForm.get('name')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('name')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Status</mat-label>
          <mat-select formControlName="active">
            @for(teamStatus of statusEnum; track teamStatus)
            {
            <mat-option [value]="teamStatus">{{ teamStatusLabels[teamStatus] }}</mat-option>
            }
          </mat-select>
          @if (teamForm.get('active')?.invalid && teamForm.get('active')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('active')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Ägartyp</mat-label>
          <mat-select formControlName="ownerType">
            @for(ownerType of teamOwnerTypeEnum; track ownerType)
            {
            <mat-option [value]="ownerType">{{ teamOwnerTypeLabels[ownerType] }}</mat-option>
            }
          </mat-select>
          @if (teamForm.get('ownerType')?.invalid && teamForm.get('ownerType')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('ownerType')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Lagtyp</mat-label>
          <mat-select formControlName="teamType">
            @for(teamType of teamTypeEnum; track teamType)
            {
            <mat-option [value]="teamType">{{ teamTypeLabels[teamType] }}</mat-option>
            }
          </mat-select>
          @if (teamForm.get('teamType')?.invalid && teamForm.get('teamType')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('teamType')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Produktionsteknikeromr</mat-label>
          <mat-select formControlName="productionTechnicianArea">
            @for(productionTechnicianArea of productionTechnicianAreaEnum; track productionTechnicianArea)
            {
            <mat-option [value]="productionTechnicianArea">{{ productionTechnicianAreaLabels[productionTechnicianArea]
              }}</mat-option>
            }
          </mat-select>
          @if (teamForm.get('productionTechnicianArea')?.invalid && teamForm.get('productionTechnicianArea')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('productionTechnicianArea')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Fördröjning skotning (dagar)</mat-label>
          <input matInput type="number" formControlName="forwardingDelayInDays" />
          @if (teamForm.get('forwardingDelayInDays')?.invalid && teamForm.get('forwardingDelayInDays')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('forwardingDelayInDays')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Produktionsledare</mat-label>
          <mat-select formControlName="productionLeaderUserId">
            @if(showStoredProductionLeaderName) {
            <mat-option disabled selected [value]="team.productionLeaderUserId">*? {{ team.productionLeaderDisplayName
              }}</mat-option>
            }
            @for(productionLeader of allProductionLeaders; track productionLeader)
            {
            <mat-option [value]="productionLeader.userId">{{ productionLeader.displayName }}</mat-option>
            }
          </mat-select>
          @if(showStoredProductionLeaderName) {
          <mat-hint [ngClass]="{ 'info-text-readonly' : isReadonly, 'info-text' : !isReadonly }">
            *? Användaren saknar korrekt roll.
          </mat-hint>
          }
          @if (teamForm.get('productionLeaderUserId')?.invalid && teamForm.get('productionLeaderUserId')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('productionLeaderUserId')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Skapat</mat-label>
          <input matInput type="string" formControlName="created" readonly />
        </mat-form-field>

        @if (teamForm.value.ownerType == 2) {
        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" style="position: relative;">
          <mat-label>Ansvarig entreprenör</mat-label>
          <mat-select formControlName="contractorId">
            @if(showStoredContractorName) {
            <mat-option disabled selected [value]="team.contractorId">*? {{team.contractorText}}</mat-option>
            }
            @for(contractor of allContractors; track contractor)
            {
            <mat-option [value]="contractor.id">{{ contractor.companyName }}</mat-option>
            }
          </mat-select>
          @if (teamForm.get('team.contractorId')?.value) {

          <mat-icon class="clickable-contractor-icon"
            (click)="navigateToContractor($event, teamForm.get('team.contractorId')?.value)"
            matTooltip="Gå till entreprenör" fontIcon="open_in_new">
          </mat-icon>
          }
          @if(showStoredContractorName) {
          <mat-hint [ngClass]="{ 'info-text-readonly' : isReadonly, 'info-text' : !isReadonly }">
            *? Entreprenör saknar avtal.
          </mat-hint>
          }
          @if (teamForm.get('contractorId')?.invalid && teamForm.get('contractorId')?.touched) {
          <mat-icon matSuffix [matTooltip]="getErrorMessage('contractorId')" matTooltipPosition="above">
            error
          </mat-icon>
          }
        </mat-form-field>
        }

        <app-entity-relation-change-transaction-details
          [entityRelationChangeTransactionDetails]="team.entityRelationChangeTransactionDetails"
          [lastModified]="team.lastModified" [isReadonly]="isReadonly">
        </app-entity-relation-change-transaction-details>

      </div>
    </div>
  </form>
  }

  <div class="machine-info-container">
    <div class="machine-list-header">
      <h4 class="form-header">Maskiner</h4>
      <mat-checkbox type="checkbox" [formControl]="showDeactivatedCheckbox">Visa inaktiva</mat-checkbox>
    </div>

    <table mat-table matSort [dataSource]="teamMachinesDataSource" class="mat-elevation-z8 machine-table">
      <ng-container matColumnDef="machineId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Maskinnr</th>
        <td mat-cell *matCellDef="let element">
          <a class="regular-link" routerLink="/machine/{{ element.id }}">
            {{ element.machineId }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="machineTypeText">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Maskintyp</th>
        <td mat-cell *matCellDef="let element">{{ element.machineTypeText }}</td>
      </ng-container>

      <ng-container matColumnDef="machineManufacturerText">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tillverkare</th>
        <td mat-cell *matCellDef="let element">{{ element.machineManufacturerText }}</td>
      </ng-container>

      <ng-container matColumnDef="modelText">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Modell</th>
        <td mat-cell *matCellDef="let element">{{ element.modelText }}</td>
      </ng-container>

      <ng-container matColumnDef="statusText">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.statusText }}</td>
      </ng-container>

      <ng-container matColumnDef="action-c">
        <th mat-header-cell *matHeaderCellDef>
          <div class="action-button-container">
            <button class="action-button" mat-raised-button (click)="addMachine()">
              Koppla maskiner </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index;">
          <div class="action-button-container">
            <button class="action-button" mat-raised-button (click)="removeMachine(element, i)">
              Frånkoppla </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="teamMachineColumns"></tr>
      <tr mat-row [hidden]="row?.clientStatus == clientStatus.Deleted ||
        !showDeactivatedCheckbox.value && row?.machineStatus === machineStatus.Deactivated"
        *matRowDef="let row; columns: teamMachineColumns;"></tr>
    </table>

    @if(getRemovedMachinesCount() && getRemovedMachinesCount().length != 0) {
    <div class="count-removed-machines">{{ getRemovedMachinesCount() }} frånkopplas maskinlaget</div>}
  </div>

</div>